class DateRange {
    start: any;
    end: any;
}

class DefinedDateRange {
    name: string;
    value: DateRange;
}

export class PickerOptions {
    startDate;
    endDate;
    minDate;
    maxDate;
    dateLimit = false;
    singleDatePicker = false;
    format;
    inactiveBeforeStart = false;
    autoApply: boolean;
    timePicker: boolean;
    preDefinedRanges: DefinedDateRange[];
    noDefaultRangeSelected: boolean;
    showRanges: boolean;
}


// WEBPACK FOOTER //
// ./client/app/global/date-range/util/date-range-picker-options.ts